import { render, staticRenderFns } from "./CrearAtencion.vue?vue&type=template&id=19b7d503"
import script from "./CrearAtencion.vue?vue&type=script&lang=js"
export * from "./CrearAtencion.vue?vue&type=script&lang=js"
import style0 from "./CrearAtencion.vue?vue&type=style&index=0&id=19b7d503&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports